/** Render old memory suggestions as ordinary text after the Prism switch. */
export function stripMemoryCandidateTags(text: string): string {
  return text.replace(/\[\/?MEMORY_CANDIDATE\]/gi, "")
}
